module.exports = __webpack_public_path__ + "prod/1.42.2/img/qspt.39b0a534.png";